import { RegionsEnum } from '../enums/RegionsEnum';
import { LocalesEnum } from '../enums/LocalesEnum';

export const getDefaultLocale = (region: RegionsEnum): LocalesEnum => (region === RegionsEnum.am
    ? LocalesEnum.en_US
    : LocalesEnum.en_GB
);
